import { sanitizeApiMessage } from './sanitize';

const FIELD_LABELS = {
  name: 'Nome',
  email: 'Email',
  phone: 'Telefone',
  subject: 'Assunto',
  message: 'Mensagem',
  form: 'Formulário',
};

function buildFieldDetails(errors) {
  if (!errors || typeof errors !== 'object') {
    return [];
  }

  return Object.entries(errors).map(([field, message]) => {
    const label = FIELD_LABELS[field] || field;
    return `${label}: ${sanitizeApiMessage(message)}`;
  });
}

function withDetails(summary, details = []) {
  return {
    summary,
    details: details.length > 0 ? details : undefined,
  };
}

function getErrorByStatus(status, data) {
  const message = sanitizeApiMessage(data?.message);
  const fieldDetails = buildFieldDetails(data?.errors);

  switch (status) {
    case 422:
      if (fieldDetails.length > 1) {
        return withDetails(
          message || 'Alguns campos precisam de ser corrigidos.',
          fieldDetails
        );
      }

      return withDetails(
        message || fieldDetails[0] || 'Alguns campos precisam de ser corrigidos.'
      );

    case 429:
      return withDetails(
        message || 'Enviou demasiadas mensagens em pouco tempo. Aguarde alguns minutos e tente novamente.'
      );

    case 500:
    case 502:
    case 503:
      return withDetails(
        message || 'O servidor não conseguiu guardar a mensagem. Tente novamente dentro de alguns minutos.'
      );

    case 400:
    case 403:
    case 413:
    case 415:
      return withDetails(message || 'Não foi possível enviar a mensagem. Tente novamente.');

    default:
      if (fieldDetails.length > 1) {
        return withDetails(message || 'Não foi possível enviar a mensagem.', fieldDetails);
      }

      return withDetails(
        message || 'Não foi possível enviar a mensagem. Tente novamente.'
      );
  }
}

export function getContactSubmitError(error) {
  if (!error) {
    return withDetails('Não foi possível enviar a mensagem. Tente novamente.');
  }

  if (error.code === 'ECONNABORTED') {
    return withDetails(
      'O pedido demorou demasiado tempo. Verifique a sua ligação e tente novamente.'
    );
  }

  if (!error.response) {
    return withDetails(
      'Não foi possível comunicar com o servidor. Verifique a sua ligação à internet e tente novamente.'
    );
  }

  return getErrorByStatus(error.response.status, error.response.data);
}
